module.exports = __webpack_public_path__ + "static/img/calendar_cat.03e51c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar_cat.jpg
// module id = FlF/
// module chunks = 1